<template>
    <div class="customer-select-component">
        <div class="form-group">
            <label for="search">Customer Search</label>
            <input v-model="search" placeholder="Start typing..." type="text" class="form-control" id="search" @input="searchCustomers()" autocomplete="off">
        </div>

        <div v-if="loading" class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>

        <ul v-if="customers.length > 0" class="list-group-flush">
            <li v-for="customer in customers" :key="customer.id" @click="selectCustomer(customer)" class="list-group-item customer-select d-flex align-items-center">
                <div class="left">
                    (ID: {{ customer.id }}) {{ customer.name }} ({{ customer.email }})
                </div>

                <div class="right">
                    <button type="button" class="ms-2 btn btn-success btn-sm">Select</button>
                </div>
            </li>
        </ul>

        <div v-if="selectedCustomer.name !== null">
            <div class="alert alert-success" role="alert">
                <strong>Selected Customer:</strong>
                <br>
                (ID: {{ selectedCustomer.id }}) {{ selectedCustomer.name }} ({{ selectedCustomer.email }})
            </div>

            <button @click="resetSelectedCustomer()" class="btn btn-danger">Unselect Customer</button>

            <input type="hidden" name="user_id" v-model="selectedCustomer.id">
            <input type="hidden" name="selected_customer" v-model="selectedCustomerJson">
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            search: null,
            selectedCustomer: {
                user_id: null,
                name: null,
                email: null
            },
            customers: [],
        };
    },

    props: {
        preloadSelectedCustomer: {
            type: Object,
            required: false,
            default: null,
        },
    },

    mounted() {
        if (this.preloadSelectedCustomer !== null) {
            this.selectedCustomer = this.preloadSelectedCustomer;
        }
    },

    computed: {
        selectedCustomerJson() {
            return JSON.stringify(this.selectedCustomer);
        }
    },

    methods: {
        searchCustomers() {
            this.loading = true;
            this.customers = [];

            axios.post(`${window.api_url}/admin/customers/search`, {
                filters: {
                    search: this.search,
                    user_type: 'customer',
                }
            }).then((response) => {
                this.loading = false;
                this.customers = response.data.customers;
            }).catch((error) => {
                this.loading = false;
                console.log(error);
            });
        },

        selectCustomer(user) {
            this.selectedCustomer = user;
            this.search = null;
            this.customers = [];
        },

        resetSelectedCustomer() {
            this.selectedCustomer = {
                user_id: null,
                name: null,
                email: null
            };
        },
    }
}
</script>

<style lang="scss" scoped>
    .customer-select {
        cursor: pointer;
    }
</style>
